export enum IdTypeEnum {
    TZ = 1,
    Passport = 2
}



// WEBPACK FOOTER //
// ./src/app/enums/IdTypeEnum.enum.ts